<template>
  <span class="star-display" :class="sizeClass">
    <span v-if="displayValue == null" class="star-display-empty">—</span>
    <el-rate
      v-else
      :value="displayValue"
      :max="max"
      disabled
      :colors="starColors"
      void-color="#C0C4CC"
      disabled-void-color="#E4E7ED"
    />
  </span>
</template>

<script>
/**
 * 星级只读展示组件（用于五育评价看板等页面）
 * @prop {Number|null} value - 展示星级（1~max），null 时显示占位符
 * @prop {Number} max - 满星数，默认 5
 * @prop {String} size - 尺寸：default / small
 */
export default {
  name: "StarDisplay",
  props: {
    value: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: 5,
    },
    size: {
      type: String,
      default: "default",
    },
  },
  computed: {
    /** 有效展示值；非法数值按 null 处理 */
    displayValue() {
      if (this.value == null || this.value === "") return null;
      var num = Number(this.value);
      if (isNaN(num) || num <= 0) return null;
      return Math.min(num, this.max);
    },
    sizeClass() {
      return this.size === "small" ? "star-display--small" : "";
    },
    starColors() {
      return ["#F7BA2A", "#F7BA2A", "#F7BA2A"];
    },
  },
};
</script>

<style scoped>
.star-display {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.star-display-empty {
  color: #c0c4cc;
  font-size: 13px;
}
.star-display--small >>> .el-rate__icon {
  font-size: 14px;
  margin-right: 2px;
}
.star-display >>> .el-rate {
  height: auto;
  line-height: 1;
}
.star-display >>> .el-rate__icon {
  margin-right: 4px;
}
</style>
